
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vender/[venderUrlId]/about",
      function () {
        return require("private-next-pages/vender/[venderUrlId]/about/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vender/[venderUrlId]/about"])
      });
    }
  